<template>
    <div class="adm-widget-message">
        Domain Listing error
    </div>
</template>
<script>
export default {
    name: 'Error'
}
</script>
